// extracted by mini-css-extract-plugin
export default {"openAiLogo":"THGQ8dbRh_jsfwWJRMwi","rotate":"ESqSiA4kIsZgbCPCw4oJ","logo":"LhiiLIO2xYDXGl_TtNQ2"};